import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import ScrollFadeWrapper from '../../ScrollFadeWrapper/ScrollFadeWrapper';
import Image from '../../Image/Image';

// Cloudflare R2 Vector
const SEO_QNA_VECTOR_URL =
  'https://assets.askhippo.co.za/Vectors/SeoQnAVector.svg';

const SeoBlogComponent = ({ data }) => {
  const { title, description, cards = [] } = data || {};

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <Box
        sx={{
          width: '1013px',
          borderRadius: '48px',
          px: '32px',
          gap: '40px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          boxSizing: 'border-box',
        }}
      >
        {/* Title */}
        <Typography
          sx={{
            fontFamily: 'Inter, sans-serif',
            fontWeight: 700,
            fontSize: '3rem',
            lineHeight: '3.25rem',
            letterSpacing: '-0.03em',
            color: '#162F3B',
            textAlign: 'center',
            whiteSpace: 'pre-line',
          }}
        >
          {title}
        </Typography>

        {/* Description */}
        {description && (
          <Typography
            sx={{
              fontFamily: 'Inter, sans-serif',
              fontWeight: 400,
              fontSize: '1.5rem',
              lineHeight: '1.75rem',
              letterSpacing: '-0.03em',
              color: '#162F3B',
              textAlign: 'center',
              whiteSpace: 'pre-line',
            }}
          >
            {description}
          </Typography>
        )}

        {/* Cards */}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '24px',
            alignItems: 'center',
          }}
        >
          {cards.map((card, i) => (
            <ScrollFadeWrapper key={i} delay={i * 0.1}>
              <Box
                sx={{
                  width: '1010px',
                  minHeight: '238px', // ⬅️ min height instead of fixed height
                  backgroundColor: '#FFFFFF',
                  borderRadius: '32px',
                  boxShadow:
                    '0px 1px 2px rgba(162, 172, 177, 0.2), 0px 12px 24px -4px rgba(22, 47, 59, 0.12)',
                  display: 'flex', // ⬅️ use flex instead of absolute layout
                  flexDirection: 'row',
                  alignItems: 'flex-start',
                  gap: '32px',
                  p: '40px 56px',
                  boxSizing: 'border-box',
                }}
              >
                {/* Vector + Icon */}
                <Box
                  sx={{
                    position: 'relative',
                    width: 120,
                    minWidth: 120,
                    height: 120,
                  }}
                >
                  <Image
                    width={120}
                    height={120}
                    src={SEO_QNA_VECTOR_URL}
                    alt="SEO Q&A vector graphic"
                    sx={{ width: '100%', height: '100%' }}
                  />

                  {card.icon && (
                    <Image
                      width={64}
                      height={64}
                      src={card.icon}
                      alt="icon"
                      sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 64,
                        height: 64,
                      }}
                    />
                  )}
                </Box>

                {/* Text + Learn more */}
                <Box
                  sx={{
                    flex: 1,
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '8px',
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 700,
                      fontSize: '1.5rem',
                      lineHeight: '1.75rem',
                      color: '#162F3B',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                    title={card.title}
                  >
                    {card.title}
                  </Typography>

                  <Typography
                    sx={{
                      fontFamily: 'Inter, sans-serif',
                      fontWeight: 400,
                      fontSize: '1rem',
                      lineHeight: '1.5rem',
                      color: '#162F3B',
                      whiteSpace: 'pre-line',
                      // ⬇️ Remove line clamp if you want full text to show
                      // display: '-webkit-box',
                      // WebkitLineClamp: 3,
                      // WebkitBoxOrient: 'vertical',
                      // overflow: 'hidden',
                    }}
                  >
                    {card.text.split(/(\*\*[^*]+\*\*)/g).map((part, i) => {
                      if (/^\*\*[^*]+\*\*$/.test(part)) {
                        return (
                          <strong key={i} style={{ fontWeight: 700 }}>
                            {part.slice(2, -2)}
                          </strong>
                        );
                      }
                      return part;
                    })}
                  </Typography>

                  {card.link && (
                    <Link
                      href={card.link}
                      sx={{
                        mt: 'auto', // ⬅️ pushes link to the bottom of the text column
                        fontFamily: 'Inter, sans-serif',
                        fontWeight: 600,
                        fontSize: '0.95rem',
                        color: '#162F3B',
                        textDecoration: 'none',
                        '&:hover': {
                          textDecoration: 'underline',
                          color: '#C7CA00',
                        },
                      }}
                    >
                      Learn more
                    </Link>
                  )}
                </Box>
              </Box>
            </ScrollFadeWrapper>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default SeoBlogComponent;
